import { render, staticRenderFns } from "./FootView.vue?vue&type=template&id=58a5dfd4"
import script from "./FootView.vue?vue&type=script&lang=js"
export * from "./FootView.vue?vue&type=script&lang=js"
import style0 from "./FootView.vue?vue&type=style&index=0&id=58a5dfd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports